export const SUPPORT_EMAIL = "support@ark-climate.de";

export const VIDEO_TUTORIALS_URL =
  "https://app.ark-climate.de/embed/dashboard/cmmx64n79000r95087sllzxsw";
